import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTypedParams, useTypedSearchParams } from 'react-router-typesafe-routes';
import AppHeader from '@/components/layouts/page-layout/app-header';
import AppHeaderMenu from '@/components/layouts/page-layout/app-header-menu';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import SearchMessageResultDetail from '@/components/search/search-message-result-detail';
import useSearchMessages from '@/hooks/search/use-search-messages';
import { useIsDesktop } from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import { clearLastPosition } from '@/stores/conversation-session';
import { setPanel } from '@/stores/layout-status';
import { generateSessionKey } from '@/utils/session';

export default function GlobalSearchBySessionRoute() {
  const { t } = useTranslation();
  const { session: sessionFromParams } = useTypedParams(ROUTES.SEARCH.BY_SESSION);

  const [{ keyword: keywordFromParams = '' }] = useTypedSearchParams(ROUTES.SEARCH.BY_SESSION);

  const [sessionKey, setSessionKey] = useState(sessionFromParams);

  // 避免同時開啟globalSearch和聊天室內搜尋時，因search值變化而影響Panel內畫面的搜尋結果
  const searchKeyword = useMemo(() => keywordFromParams, []);

  const { messages } = useSearchMessages(searchKeyword);

  const isDesktop = useIsDesktop();

  const handleNavigateBack = () => {
    if (isDesktop) {
      setPanel('search');
    }
  };
  const selectedMessageSet = useMemo(
    () =>
      sessionKey
        ? messages.find((m) => {
            const key =
              m.GroupId > 0 ? generateSessionKey('group', m.GroupId) : generateSessionKey('session', m.ChatSessionId);
            return key === sessionKey;
          })
        : undefined,
    [messages, sessionKey],
  );

  useEffect(() => {
    if (sessionFromParams) {
      setSessionKey(sessionFromParams);
    }

    // 避免點擊訊息進入相同的聊天室，因lastPosition未清空而無法正確定位
    clearLastPosition(sessionFromParams);
  }, [sessionFromParams]);

  return (
    <PageLayout
      constrainHeight
      enablePullToRefresh={false}
      className='gap-y-0 max-w-100vw overflow-hidden'
      title={t('search.placeholder')}
      headerConfig={{
        navigateBack: true,
        onNavigateBack: handleNavigateBack,
        headerLabel: <h5 className='flex-1 text-body1 font-bold text-center'>{selectedMessageSet?.SessionName}</h5>,
        elementBeforeNav: isDesktop && (
          <AppHeader
            actions={<AppHeaderMenu />}
            className='flex-1 text-left text-2xl font-bold'>
            {t('nav.messages')}
          </AppHeader>
        ),
      }}>
      {sessionKey && selectedMessageSet ? (
        <SearchMessageResultDetail
          keyword={searchKeyword}
          selectedMessageSet={selectedMessageSet}
        />
      ) : null}
    </PageLayout>
  );
}
